<template>
  <gg-modal @close="close" :is-active="dialog">
    <template v-slot:toolbar>Remove subdomain</template>
    <template v-slot:body>
      <p v-if="subdomain">
        Are you sure you wish to <strong>permanently</strong> remove the subdomain “{{ subdomain.domain }}”?
      </p>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close" text>Close</gg-btn>
      <gg-btn primary :loading="loading" @click="deleteSubdomain">Remove</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'
import amapi from '@/api/amapi'

export default {
  name: 'DeleteSubdomainModal',
  mixins: [modalMixin],
  props: {
    subdomain: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions(['reportError', 'reportSuccess']),
    async deleteSubdomain () {
      this.loading = true
      let data = {
        api2_module: 'SubDomain',
        api2_method: 'delsubdomain',
        domain: this.subdomain.domain,
        _username: this.$route.query.user,
      }

      try {
        const response = await amapi.cpanel_api2({ ...data })
        if (response.error) {
          this.loading = false
          this.reportError(response.error)
          return
        }
        this.reportSuccess(`The subdomain ${data.domain} has been removed`)
        this.loading = false
        this.$emit('addondomain-removed')
        this.close()
      } catch (e) {
        this.loading = false
        this.reportError(e.resultmsg)
      }
    },
  },
}
</script>
